import axios from "axios";
import { JSON_CONTENT_FORM_CONFIG } from "../Config";
import { SELF_USER_LOAD_SUCCESS, SELECT_ORGANIZATION, DESELECT_ORGANIZATION } from "./types";

export const getSelfUser = () => async dispatch => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/get-self-user/`, JSON_CONTENT_FORM_CONFIG);
    dispatch({
        type: SELF_USER_LOAD_SUCCESS,
        payload: res.data.user
    });
};

export const getUserList = async (page=1, per_page=10, suborganization_ids=[], groups=[]) => {
    let params = `page=${page}&per_page=${per_page}`;
    if (groups.length > 0)
        params += `&groups=${JSON.stringify(groups)}`;
    if (suborganization_ids.length > 0){
        params += '&suborganization_ids=' + JSON.stringify(suborganization_ids)
    }
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/get-user-list/?${params}`, JSON_CONTENT_FORM_CONFIG);
    return res.data;
};

export const selectOrganization = ( organization ) => async dispatch => {
    dispatch({
        type: SELECT_ORGANIZATION,
        payload: organization
    })
};

export const deselectOrganization = ( organization ) => async dispatch => {
    dispatch({
        type: DESELECT_ORGANIZATION,
        payload: organization
    })
};